module.exports = __webpack_public_path__ + "static/media/sbom-slide-3.69b142cd.jpg";